'use client';

import React from 'react';
import { useFormContext } from 'react-hook-form';
import FormSection from './FormSection';
import FormField from './FormField';
import RadioOption from './RadioOption';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import TextareaInput from './TextareaInput';
import type { RSVPFormData } from './RSVPPageClient';

const accommodationOptions = [
  { value: 'yes', label: 'Yes, please arrange accommodation' },
  { value: 'no', label: "No, I'll arrange my own accommodation" },
  { value: 'unsure', label: "I haven\'t decided yet" },
];

export default function Section4BhopalStay() {
  const { register } = useFormContext<RSVPFormData>();

  return (
    <FormSection number={4} title="Your Stay in Bhopal">
      <FormField label="Do you need accommodation in Bhopal?">
        <div className="grid gap-2 mt-1">
          {accommodationOptions.map((opt) => (
            <RadioOption
              key={`bhopal-accom-${opt.value}`}
              name="bhopalAccommodation"
              value={opt.value}
              label={opt.label}
              registerProps={register('bhopalAccommodation')}
            />
          ))}
        </div>
      </FormField>

      <FormField
        label="When would you like your Bhopal accommodation to start?"
        htmlFor="bhopalCheckIn"
      >
        <SelectInput
          id="bhopalCheckIn"
          registerProps={register('bhopalCheckIn')}
        >
          <option value="">Select check-in date</option>
          <option value="30 December 2026">30 December 2026</option>
          <option value="31 December 2026">31 December 2026</option>
          <option value="1 January 2027">1 January 2027</option>
          <option value="2 January 2027">2 January 2027</option>
          <option value="3 January 2027">3 January 2027</option>
        </SelectInput>
      </FormField>

      <FormField
        label="When will you leave Bhopal?"
        htmlFor="bhopalCheckOut"
      >
        <SelectInput
          id="bhopalCheckOut"
          registerProps={register('bhopalCheckOut')}
        >
          <option value="">Select check-out date</option>
          <option value="31 December 2026">31 December 2026</option>
          <option value="1 January 2027">1 January 2027</option>
          <option value="2 January 2027">2 January 2027</option>
          <option value="3 January 2027">3 January 2027</option>
          <option value="4 January 2027">4 January 2027</option>
        </SelectInput>
      </FormField>

      <FormField
        label="Number of rooms required"
        htmlFor="bhopalRooms"
      >
        <TextInput
          id="bhopalRooms"
          type="number"
          min={0}
          max={20}
          registerProps={register('bhopalRooms', {
            valueAsNumber: true,
            min: 0,
            max: 20,
          })}
        />
      </FormField>

      <FormField label="Who will be staying with you?">
        <TextareaInput
          placeholder="Please mention names and relationship — e.g. Rahul (husband), Ananya (daughter)"
          registerProps={register('bhopalRoomGuests')}
        />
      </FormField>
    </FormSection>
  );
}